const funs = {
  getTime() {
    const now = new Date();
    const year = now.getFullYear(); // 获取年份
    const month = now.getMonth() + 1; // 获取月份（注意要加上1）
    const day = now.getDate(); // 获取日期
    const hour = now.getHours(); // 获取小时
    const minute = now.getMinutes(); // 获取分钟
    const second = now.getSeconds(); // 获取秒数
    return `${year}-${month}-${day}`;

    //`${year}-${month}-${day} ${hour}:${minute}:${second}`
  },
  //转换图片为64位
  Base64(file) {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();
      let imgResult = "";
      reader.readAsDataURL(file);
      reader.onload = function() {
        imgResult = reader.result;
      };
      reader.onerror = function(error) {
        reject(error);
      };
      reader.onloadend = function() {
        resolve(imgResult);
      };
    });
  }
};

export default funs;



// WEBPACK FOOTER //
// ./src/uitls/funs.js